import React from "react";
import { motion } from "framer-motion";
import HomeLayout from "../../layouts/home.layout";
import CustomLink from "@/common/ui/CustomLink";

const PageNotFoundPage: React.FC = () => {
  return (
    <HomeLayout>
      <div className="flex flex-col items-center justify-center min-h-screen text-text-primary">
        <motion.h1
          className="text-4xl md:text-9xl font-bold mb-2 md:mb-8"
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{
            type: "spring",
            stiffness: 260,
            damping: 20,
            duration: 1.5,
          }}
        >
          404
        </motion.h1>

        <motion.p
          className="text-xs md:text-2xl mb-4 md:mb-8 text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          Oops! The page you're looking for doesn't exist.
        </motion.p>

        <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
          <CustomLink link={{ value: "/", text: "Go Home" }} variant="default" className="min-w-72" />
        </motion.div>
      </div>
    </HomeLayout>
  );
};

export default PageNotFoundPage;
